import React from "react";
import { authRoles } from "app/auth";

export const DocRouteConfig = {
	settings: {
		layout: {},
	},
	auth: authRoles.staff,
	routes: [
		{
			path: "/game/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/banner/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/banner",
			component: React.lazy(() => import("./docs/Docs")),
			// component: Games,
		},
		{
			path: "/Users/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/Users",
			component: React.lazy(() => import("./docs/Docs")),
			// component: Games,
		},
		{
			path: "/etc/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/etc",
			component: React.lazy(() => import("./Etc")),
			// component: Games,
		},
		{
			path: "/game",
			component: React.lazy(() => import("./Rules")),
			// component: Games,
		},
		{
			path: "/Withdraw/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/Withdraw",
			component: React.lazy(() => import("./docs/Docs")),
			// component: Games,
		},
	],
};
export const DocRouteAuthConfig = {
	settings: {
		layout: {},
	},
	auth: authRoles.admin,
	routes: [
		{
			path: "/Admin/:id/:docHandle?",
			component: React.lazy(() => import("./doc/Doc")),
			// component: Game,
		},
		{
			path: "/Admin",
			component: React.lazy(() => import("./docs/Docs")),
			// component: Games,
		},
	],
};
